import { render, staticRenderFns } from "./RecentHackathons.vue?vue&type=template&id=28498860&scoped=true&"
import script from "./RecentHackathons.vue?vue&type=script&lang=js&"
export * from "./RecentHackathons.vue?vue&type=script&lang=js&"
import style0 from "./RecentHackathons.vue?vue&type=style&index=0&id=28498860&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28498860",
  null
  
)

export default component.exports